import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const AcceptChallenge = gql`
  mutation AcceptChallenge(
    $challengeId: String
    $otpCode: String
    $input: AcceptChallengeRequestInput
  ) {
    acceptChallenge(
      challengeId: $challengeId
      otpCode: $otpCode
      input: $input
    ) {
      ... on AcceptChallengeSuccess {
        challengeId
        challengeContext
        challengeVerified
        __typename
      }
      ... on AcceptChallengeError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;
export default AcceptChallenge;
